module.exports = __webpack_public_path__ + "public/SiteIcons/map-pin-small.png?528304f4";